"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildSquarePhotoUrl = exports.buildLandscapePhotoUrl = void 0;
const cloudinary_1 = require("./cloudinary");
const UNSPLASH_IMAGE_HOST_PATTERN = /^https:\/\/[a-z0-9-]+\.unsplash\.com\//;
const buildUnsplashCropUrl = (url, width, height) => {
    if (!UNSPLASH_IMAGE_HOST_PATTERN.test(url)) {
        return url;
    }
    let parsed;
    try {
        parsed = new URL(url);
    }
    catch {
        return url;
    }
    parsed.searchParams.set("fit", "crop");
    parsed.searchParams.set("w", String(width));
    parsed.searchParams.set("h", String(height));
    return parsed.toString();
};
const buildLandscapePhotoUrl = (url) => (0, cloudinary_1.buildCloudinaryLandscapeUrl)(buildUnsplashCropUrl(url, 1200, 675)) ?? url;
exports.buildLandscapePhotoUrl = buildLandscapePhotoUrl;
const buildSquarePhotoUrl = (url) => (0, cloudinary_1.buildCloudinarySquareUrl)(buildUnsplashCropUrl(url, 600, 600)) ?? url;
exports.buildSquarePhotoUrl = buildSquarePhotoUrl;
